import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext } from "react";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { eventService } from "../services/EventService";
import { votersService } from "../services/VotersService";
import { lookupsService } from "../services/LookupsService";
import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import AddEventDelimitationStaff from "../componets/AddEventDelimitationStaff";
import AddEventPareameters from "../componets/AddEventPareameters";
import { formatDate } from "../config/Config";
import ReactDOM from "react-dom";
import StaffDetails from "./StaffDetails";
import { Reports } from "../pages/reports/Reports";
import { reportService } from "../services/ReportService";
import { PrintOut } from "../pages/reports/PrintOut";
import ScreenLoader from "./ScreenLoader";
import { AppDB } from "../App";
import { permissionLookUp } from "../constants";
import AddSignature from "./AddSignature";
import GenericFileCapture from "./GenericFileCapture";
import GenericUploadFileTable from "./GenericUploadFileTable";
import ViewDetails from "./ViewDetails";
import DocumentTypesService from "../services/DocumentsService";
import { helper } from "./utils/helper";
import MultiFilterSearch from "./MultiFilterSearch";

export default function EditEventDelimitation({
	selectedEvent = null,
	eventGroup = null,
	setData = [],
	buttonIcon = "pi pi-save",
	show = false,
	setShow,
	eventTypes,
	GetAllEvents,
	setSelectedEvent = null
}) {
	var [showEventDelimitationStaffForm, setShowEventDelimitationStaffForm] = useState(false);
	var [showSearchElector, setShowSeachElector] = useState(false);
	var [loading, setLoading] = useState(false);
	var [screenLoading, setScreenLoading] = useState(false);
	var [form, setForm] = useState({ idNumber: "" });
	var [formErrorMessage, setFormErrorMessage] = useState({});
	const { toast } = useContext(AppDB);
	var [selectedType, setSelected] = useState(null);
	var [showSearchElector, setShowSearchElector] = useState(null);
	const [eventParameter, setEventParameter] = useState(null);
	const [parametersList, setParametersList] = useState([]);
	const [eventParameters, setEventParameters] = useState([]);
	const [savedEventParameters, setSavedEventParameters] = useState([]);
	const [eventStaff, setEventStaff] = useState([]);
	const [isLoading, setisLoading] = useState(false);
	const [showAddParameterForm, setShowAddParameterForm] = useState(false);
	const [selectedOptionalParams, setSelectedOptionalParams] = useState({}); // Track optional fields
	const [error, setError] = useState("");
	const [showParameters, setshowParameters] = useState(true);
	const [reloadParams, setReloadParams] = useState(false);
	const { permission } = useContext(AppDB);
	const [addShowDocuments, setAddShowDocuments] = useState(false);

	function GetSavedSavedEventParameters() {
		setisLoading(true);
		eventService
			.getSavedEventParameters({
				eventID: selectedEvent?.eventID,
				DelimitationID: selectedEvent?.eventDelimitationId,
				DelimitationLevelID: selectedEvent?.eventDelimitationLevelId,
				PageIndex: 1,
				PageSize: 10000
			})
			.then((response) => {
				setSavedEventParameters(response);
				setisLoading(false);
			})
			.catch((err) => {
				setisLoading(false);
				console.log(err);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "There is a technical problem fetching event staff, Please Try Again",
					life: 3000
				});
			});
	}
	function GetEventCategoryParametersById(id) {
		setisLoading(true);

		eventService
			.GetCategoryParametersByIdAsync(id)
			.then((data) => {
				setisLoading(false);
				setEventParameters(data);
				setSelected(null);
			})
			.catch((err) => {
				setisLoading(false);
				console.log(err);
			});
	}

	useEffect(() => {
		GetEventCategoryParametersById(selectedEvent?.eventCategoryID);
		GetEventStaff();
		GetSavedSavedEventParameters();
		documentTypes();
		getDocuments(selectedEvent?.eventID);
	}, []);

	async function GetEventStaff() {
		setisLoading(true);
		eventService
			.getAllEventStaff({
				eventID: selectedEvent?.eventID,
				DelimitationID: selectedEvent?.eventDelimitationId,
				DelimitationLevelID: selectedEvent?.eventDelimitationLevelId,
				PageIndex: 1,
				PageSize: 10000
			})
			.then((response) => {
				setEventStaff(response);
				setisLoading(false);
			})
			.catch((err) => {
				setisLoading(false);
				console.log(err);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "There is a technical problem fetching event staff, Please Try Again",
					life: 3000
				});
			});
	}

	const [showuploadDocs, setshowuploadDocs] = useState(false);
	const [projectPlanData, setprojectPlanData] = useState([]);

	var [showFileUploader, setShowFileUploader] = useState(false);
	var [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);

	var [loading, setLoading] = useState(false);
	var [refresh, setRefresh] = useState(true);
	var [delimitationdocuments, setdelimitationdocuments] = useState([]);
	var [documents, setDocuments] = useState([]);

	let eventDocuments = JSON.parse(JSON.stringify(fileUploaderDocuments));
	eventDocuments = eventDocuments.map((doc) => {
		var _do = doc.binaryData.split(",");
		if (_do.length >= 2) {
			doc.binaryData = _do[1];
		}
		return doc;
	});

	// Handles dropdown change
	const handleDropdownChange = (e) => {
		setEventParameter(e.value);
	};

	// Adds the selected parameter to the list
	const addParameterToList = () => {
		if (eventParameter && !parametersList.some((p) => p.parameterID === eventParameter.parameterID)) {
			setParametersList([...parametersList, { ...eventParameter, value: "" }]);
			setEventParameter(null); // Reset dropdown after adding
		}
	};

	// Updates value of a parameter
	const updateParameterValue = (index, newValue) => {
		const updatedList = [...parametersList];
		updatedList[index].value = newValue;
		setParametersList(updatedList);
	};

	useEffect(() => {
		if (selectedEvent) {
			setEventDetails({
				eventID: selectedEvent.eventID,
				name: selectedEvent.eventName,
				description: selectedEvent.description
			});
		}
	}, [selectedEvent, GetAllEvents]);

	// Removes a parameter from the list
	const removeParameter = (index) => {
		setParametersList(parametersList.filter((_, i) => i !== index));
	};
	const [eventDetails, setEventDetails] = useState({
		eventID: selectedEvent?.eventID,
		name: selectedEvent?.eventName,
		description: selectedEvent?.description
	});
	const [documentForm, setDocumentForm] = useState([]);

	const HandleuploadDelimitationDocuments = () => {
		setisLoading(true);
		let payload = {
			documents: documentForm,
			eventID: selectedEvent?.eventID,
			eventDelimitationLevelID: selectedEvent?.eventDelimitationLevelId ? selectedEvent?.eventDelimitationLevelId : null,
			eventDelimitationID: selectedEvent?.eventDelimitationId ? selectedEvent?.eventDelimitationId : null
		};
		eventService
			.addDelimitationDocuments(payload)
			.then((resp) => {
				setAddShowDocuments(false);
				setisLoading(false);
				if (resp?.success) {
					getDocuments(selectedEvent?.eventID);
					setDocumentForm(null);
					return toast.show({
						severity: resp?.success ? "success" : "error",
						summary: "Message",
						detail: resp?.message,
						life: 3000
					});
				}
			})
			.catch((err) => {
				console.log(err);
				setisLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "There is a technical problem, Please Try Again",
					life: 3000
				});
			});
	};

	const [eventdocumentTypes, seteventdocumentTypes] = useState(null);

	const documentTypes = () => {
		lookupsService
			.getDocumentTypes({
				DocumentCategoryID: 4
			})
			.then((res) => {
				seteventdocumentTypes(res);
				console.log(res);
			});
	};
	const getDocuments = (id) => {
		setisLoading(true);
		eventService
			.getDelimitationDocuments(id)
			.then((resp) => {
				setisLoading(false);
				setdelimitationdocuments(resp?.documents);
			})
			.catch((err) => {
				setisLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "There is a technical problem, Please Try Again",
					life: 3000
				});
			});
	};
	var [hasActiveChanges, setHasActiveChanges] = useState(false);
	function UpdateEventDetails(propertyName, e) {
		setEventDetails({ ...eventDetails, [propertyName]: e.target.value });

		var changed = false;
		if (propertyName == "name") {
			if (e.target.value != selectedEvent?.eventName || eventDetails.description != selectedEvent?.description) changed = true;
		} else if (propertyName == "description") {
			if (e.target.value != selectedEvent?.description || eventDetails.name != selectedEvent?.eventName) changed = true;
		}
		setHasActiveChanges(changed);
	}
	function EditEvent() {
		setisLoading(true);
		eventService
			.editEvent(eventDetails)
			.then((response) => {
				setisLoading(false);
				GetAllEvents();
				setHasActiveChanges(false);
				setSelectedEvent((prev) => ({
					...prev,
					eventName: eventDetails.name,
					name: eventDetails.name,
					description: eventDetails.description,
					eventDelimitationLevelId: prev?.eventDelimitationLevelId
				}));
				return toast.show({
					severity: response?.success ? "success" : "error",
					summary: "Message",
					detail: response?.message,
					life: 3000
				});
			})
			.catch((err) => {
				console.log(err);
				setisLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "There is a technical problem, Please Try Again",
					life: 3000
				});
			});
	}
	var [voterForm, setVoterForm] = useState({
		Surname: "",
		Firstname: "",
		IDNumber: "",
		RegistrationNumber: "",
		ContactNumber: "",
		GenderID: "",
		EmailAddress: "",
		Address: "",
		DateAppointed: "",
		StaffTypeID: "",
		DelimitationLevelID: "",
		DelimitationID: "",
		EventDelimitationID: selectedEvent?.eventDelimitationId,
		RoleId: "",
		EventID: selectedEvent?.eventID,
		StartDate: "",
		EndDate: ""
		// "binaryData": []
	});
	var [formErrorMessage, setFormErrorMessage] = useState({
		Surname: "",
		Firstname: "",
		IDNumber: "",
		RegistrationNumber: "",
		ContactNumber: "",
		GenderID: "",
		EmailAddress: "",
		Address: "",
		DateAppointed: "",
		StaffTypeID: "",
		DelimitationLevelID: "",
		DelimitationID: "",
		EventDelimitationID: "",
		RoleId: "",
		EventID: "",
		StartDate: "",
		EndDate: ""
		// "binaryData": []
	});

	const [voterData, setVoterData] = useState(null);
	function FormValitation() {
		var valid = true;

		Object.keys(voterForm).forEach((key) => {
			if (key.toLowerCase().startsWith("email")) {
				setFormErrorMessage((form) => ({ ...form, [key]: "" }));
			} else {
				if (!voterForm[key] && key != "EventDelimitationID") {
					setFormErrorMessage((form) => ({ ...form, [key]: "Required." }));
					valid = false;
				} else {
					setFormErrorMessage((form) => ({ ...form, [key]: "" }));
				}
			}
		});
		return valid;
	}
	function OnInputValidation(key, value = "", submitClick = false) {
		var valid = true;

		if (submitClick) {
			value = voterForm[key];
		}

		if (!value) {
			setFormErrorMessage((form) => ({ ...form, [key]: "Required." }));
			valid = false;
		} else {
			setFormErrorMessage((form) => ({ ...form, [key]: "" }));
		}

		if (valid && key == "IDNumber" && value.length != 12) {
			setFormErrorMessage((form) => ({ ...form, IDNumber: "Invalid ID Number." }));
			valid = false;
		}

		return valid;
	}
	function SearchElector() {
		setisLoading(true);
		eventService
			.IsVoterNotAlreadyAStaffMemberCheckAsync(voterData?.idNumber)
			.then((check) => {
				console.log(check);
				if (check.success) {
					votersService.getByIDNumber(voterData?.idNumber).then((res) => {
						setisLoading(false);
						if (res) {
							//email
							var email = res.contactDetails.filter((e) => e.contactType.name === "Email")?.at(0)?.contactDetail || "";
							//cell number 1
							var cell1 = res.contactDetails.filter((e) => e.contactType.name === "Cellphone")?.at(0)?.contactDetail || "";
							var cell1Code =
								res.contactDetails.filter((e) => e.contactType.name === "Cellphone")?.at(0)?.countryCode?.countryCodeID || "";

							setVoterForm({
								Surname: res.surname,
								Firstname: res.firstname,
								IDNumber: voterForm.IDNumber,
								RegistrationNumber: res?.registrationNumber,
								ContactNumber: `+${cell1Code}${cell1}`,
								GenderID: res.genderID,
								EmailAddress: email,
								Address: "",
								DateAppointed: "",
								StaffTypeID: "",
								DelimitationLevelID: "",
								DelimitationID: "",
								EventDelimitationID: selectedEvent?.eventDelimitationId,
								RoleId: "",
								EventID: selectedEvent?.eventID
							});
							if (res?.eligibleStatus === "Y") {
								setShowSearchElector(false);
								setShowEventDelimitationStaffForm(true);
							} else {
								setisLoading(false);

								return toast.show({
									severity: "error",
									summary: "Message",
									detail: "Elector not eligible to vote.",
									life: 3000
								});
							}
						} else {
							setisLoading(false);
							return toast.show({
								severity: "error",
								summary: "Message",
								detail: "Elector not found.",
								life: 3000
							});
						}
					});
				} else {
					setisLoading(false);
					return toast.show({
						severity: "error",
						summary: "Message",
						detail: check?.message,
						life: 3000
					});
				}
			})
			.catch((error) => {
				return toast.show({
					severity: "error",
					summary: "Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}

	function SubmitForm() {
		if (!FormValitation()) {
			return;
		}
		setScreenLoading(true);
		eventService
			.createStaff(voterForm)
			.then((res) => {
				setisLoading(false);

				if (res?.success) {
					setVoterForm({});
					setFormErrorMessage({});
					GetEventStaff();
					setShowEventDelimitationStaffForm(false);
				}
				setScreenLoading(false);
				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				setScreenLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}

	const [ShowStaffDetails, setShowStaffDetails] = useState(false);
	const [staffInfo, setStaffInfo] = useState(null);
	const [panel, setPanel] = useState("staff");
	const handleShowStaff = (data) => {
		if (data) {
			setStaffInfo(data);
			setShowStaffDetails(true);
		}
	};

	const documentService = new DocumentTypesService();

	const [showDocumentDetails, setshowDocumentDetails] = useState();
	const [documentDetails, setdocumentDetails] = useState(null);
	const handleShowDocuments = (data) => {
		setisLoading(true);
		documentService
			.downloadDocument(data?.documentID)
			.then((res) => {
				setisLoading(false);
				helper.downloadFile(res, data.title, data.contentType);
			})
			.catch((err) => {
				setisLoading(false);

				toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, there is a technical problem. Please try again.",
					life: 3000
				});
			})
			.finally(() => {
				setisLoading(false);
			});
	};

	const handleRemoveDocuments = (data) => {
		setdocumentDetails(data);
		setLoading(true);
		eventService
			.deleteEventDocument(data?.documentID)
			.then((res) => {
				setisLoading(false);

				if (res?.success) {
					getDocuments(selectedEvent?.eventID);
				}
				setScreenLoading(false);
				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				setScreenLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	};
	const toggleOptionalParam = (parameterID) => {
		setSelectedOptionalParams((prev) => ({
			...prev,
			[parameterID]: !prev[parameterID]
		}));

		setParametersList((prev) => {
			const exists = prev.some((param) => param.parameterID === parameterID);
			return exists
				? prev.filter((param) => param.parameterID !== parameterID)
				: [...prev, eventParameters.find((p) => p.parameterID === parameterID)]; // Add if checked
		});
	};
	function DeleteStaff(data) {
		setLoading(true);
		var payload = {
			EventID: selectedEvent?.eventID,
			StaffID: data.staffID,
			DelimitationID: selectedEvent?.eventDelimitationId,
			EventDelimitationLevelID: selectedEvent?.eventDelimitationLevelId
		};
		eventService
			.deleteEventStaff(payload)
			.then((res) => {
				setisLoading(false);

				if (res?.success) {
					GetEventStaff();
				}
				setScreenLoading(false);
				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				setScreenLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}

	const [activeIndex, setActiveIndex] = useState(0); // Default to first tab

	const handleDownloadReport = () => {
		let reportParameters;
		if (activeIndex == 0) {
			reportParameters = {
				ReportID: 12,
				eventid: selectedEvent.eventID,
				DelimitationLevelID: selectedEvent?.eventDelimitationLevelId,
				DelimitationID: selectedEvent?.eventDelimitationId,
				IncludeSubdelimitations: true
			};
			getReport(reportParameters);
		} else {
			reportParameters = {
				ReportID: 13,
				eventid: selectedEvent.eventID,
				DelimitationLevelID: selectedEvent?.eventDelimitationLevelId,
				DelimitationID: selectedEvent?.eventDelimitationId,
				IncludeSubdelimitations: true
			};
			getReport(reportParameters);
		}
	};
	const [base64, setBase64] = useState(null);
	const [showReportDialog, setReportShowDialog] = useState(false);
	const getReport = (data) => {
		setisLoading(true);
		reportService
			.getReport(data)
			.then((response) => {
				setisLoading(false);

				if (response?.success) {
					setReportShowDialog(true);
					setBase64(response.data);
					toast.show({ severity: "success", summary: "", detail: response.message, life: 3000 });
				} else {
					toast.show({ severity: "error", summary: "Message", detail: "No data found", life: 3000 });
				}
			})
			.catch((err) => {
				console.log(err);
				setisLoading(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};

	const [uploaded, setUploaded] = useState(false);
	return (
		<>
			<Dialog
				draggable={false}
				header={
					<>
						<span>
							{selectedEvent?.eventDelimitationLevelId ? "Event Delimitation" : "Event"} - {selectedEvent?.name}
						</span>
					</>
				}
				footer={
					<>
						<Button label="Print" onClick={handleDownloadReport} className="p-button-primary" />
						<Button
							label="Close"
							onClick={(e) => {
								setShow(false);
								setVoterForm({});
								setFormErrorMessage({});
							}}
							className="p-button-danger"
						/>
					</>
				}
				visible={show}
				onHide={(e) => setShow(false)}
				style={{ width: "100%", height: "100%" }}
			>
				<PrintOut base64={base64} setBase64={setBase64} showDialog={showReportDialog} setShowDialog={setReportShowDialog} />
				<ScreenLoader visible={isLoading} />
				<div className="grid">
					<div className="col-12 lg:col-12">
						<section className="p-4 border rounded bg-gray-100">
							<div className="grid">
								<div className="col-12  lg:col-6">
									<TextInput label={<b>Name</b>} value={eventDetails?.name} onChange={(e) => UpdateEventDetails("name", e)} />
								</div>
								<div className="col-12  lg:col-6">
									<TextInput
										label={<b>Description</b>}
										value={eventDetails.description}
										onChange={(e) => UpdateEventDetails("description", e)}
									/>
								</div>
							</div>
							<div className="grid">
								<div className="col-12  lg:col-6">
									<TextInput label={<b>Category</b>} value={selectedEvent?.categoryName} disabled />
								</div>
								<div className="col-12  lg:col-6">
									<TextInput label={<b>Type</b>} value={selectedEvent?.eventType} disabled={true} />
								</div>
							</div>

							<Button
								label="Save"
								onClick={() => EditEvent()}
								className="p-button-success"
								icon="pi pi-pencil"
								disabled={!hasActiveChanges}
							/>
							<br />
						</section>
						<TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
							<TabPanel header="Staff">
								{permission?.subModules?.EventStaff?.includes(permissionLookUp.Create) && (
									<Toolbar
										right={
											<div>
												<Button
													className="p-button-success mr-2"
													icon="pi pi-plus"
													label="Add Staff"
													onClick={() => {
														setShowSearchElector(true);
													}}
												/>
											</div>
										}
									/>
								)}
								<DataTable
									className="remove-border"
									size="small"
									scrollable={true}
									value={eventStaff}
									dataKey="id"
									style={{ width: "100%" }}
								>
									<Column
										style={{ width: "100px", margin: "5px" }}
										align="left"
										className="my-2"
										header="#"
										body={(rowData, options) => options.rowIndex + 1}
									/>
									<Column
										style={{ width: "200px", margin: "5px" }}
										align="left"
										className="my-2"
										header="First Name"
										field="firstname"
										sortable
									></Column>
									<Column
										style={{ width: "200px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Surname"
										field="surname"
										sortable
									></Column>
									<Column
										style={{ width: "200px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Gender"
										field="genderName"
										sortable
									></Column>
									<Column
										style={{ width: "200px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Staff Role"
										field="roleName"
										sortable
									></Column>
									<Column
										style={{ width: "200px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Staff Type"
										field="staffTypeName"
										sortable
									></Column>
									{/* <Column style={{ width: "250px" }} header ="Staff Number" field="staffNumber" sortable ></Column> */}
									<Column
										style={{ width: "200px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Demarcation Level"
										field="demarcationLevelName"
										sortable
									></Column>
									<Column
										style={{ width: "200px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Demarcation Name"
										field="demarcationName"
										sortable
									></Column>
									<Column
										header="Actions"
										align="left"
										body={(rowData) => (
											<div className="flex gap-1 py-1 my-2">
												{permission?.subModules?.EventStaff?.includes(permissionLookUp.Delete) && (
													<div className="">
														<Button
															disabled={rowData.leaf}
															type="button"
															icon="pi pi-times"
															severity="danger"
															tooltip="Click to remove"
															rounded
															onClick={() => DeleteStaff(rowData)}
														/>
													</div>
												)}
												{permission?.subModules?.EventStaff?.includes(permissionLookUp.Read) && (
													<div className=" -1">
														<Button
															disabled={rowData.leaf}
															type="button"
															icon="pi pi-eye"
															severity="success"
															tooltip="Click to view staff details"
															rounded
															onClick={() => handleShowStaff(rowData)}
														/>
													</div>
												)}
											</div>
										)}
									/>
									{/* <Column style={{ width: "250px" }} header ="Demarcation" field="dateAppointed" body={(e) => formatDate(e.dateAppointed)}  sortable></Column> */}
								</DataTable>
							</TabPanel>
							{((selectedEvent?.eventTypeID !== 1 && selectedEvent?.level === 3) ||
								selectedEvent?.level == 0 ||
								selectedEvent?.level == 2) && (
								<TabPanel
									header="Parameters"
									onClick={() => {
										setPanel("parameters");
									}}
								>
									{permission?.subModules?.EventParameters?.includes(permissionLookUp.Create) && (
										<Toolbar
											right={
												<div>
													<Button
														className={`${(selectedEvent?.eventTypeID !== 1 && selectedEvent?.level === 3) || selectedEvent?.level === 2 || selectedEvent?.level === 0 ? "p-button-success mr-2" : "hidden"}`}
														icon="pi pi-plus"
														label="Add Parameters"
														onClick={() => {
															setShowAddParameterForm(true);
														}}
													/>
												</div>
											}
										/>
									)}
									<DataTable
										className="remove-border"
										size="small"
										scrollable={true}
										value={savedEventParameters}
										dataKey="eventParameterID"
										style={{ width: "100%" }}
									>
										<Column style={{ width: "100px" }} header="#" body={(rowData, options) => options.rowIndex + 1} />
										<Column style={{ width: "250px" }} header="Name" field="parameterName" sortable></Column>
										<Column style={{ width: "250px" }} header="Value" field="value" sortable></Column>
										<Column
											style={{ width: "250px" }}
											header="Start Date"
											field="startDate"
											body={(e) => formatDate(e.startDate)}
											sortable
										></Column>
										<Column
											style={{ width: "250px" }}
											header="End Date"
											field="endDate"
											body={(e) => formatDate(e.endDate)}
											sortable
										></Column>
										<Column style={{ width: "250px" }} header="Created by" field="createdBy" sortable></Column>
										<Column
											style={{ width: "250px" }}
											header="Date Created"
											field="createdDate"
											body={(e) => formatDate(e.createdDate)}
											sortable
										></Column>
									</DataTable>
								</TabPanel>
							)}
							<TabPanel header="Documents">
								<Toolbar
									right={
										<div>
											<Button
												className="p-button-success mr-2"
												icon="pi pi-plus"
												label="Add Documents"
												onClick={() => {
													setAddShowDocuments(true);
												}}
											/>
											<div className="col-12  lg:col-6">
												<Dialog
													footer={
														<>
															<Button
																className="p-button-success mr-2"
																icon="pi pi-plus"
																label="Submit"
																onClick={() => {
																	HandleuploadDelimitationDocuments();
																}}
															/>
															<Button
																className="p-button-danger mr-2"
																icon="pi pi-times"
																label="Close"
																onClick={() => {
																	setAddShowDocuments(false);
																	setDocumentForm(null);
																}}
															/>
														</>
													}
													visible={addShowDocuments}
													style={{ width: "95%", height: "100%" }}
													draggable={false}
													header={
														<>
															<span>Add Event document for {selectedEvent?.name}</span>
														</>
													}
													onHide={() => {
														setAddShowDocuments(false);
														setDocumentForm(null);
													}}
												>
													<AddSignature
														setsignatureData={setDocumentForm}
														signatureData={documentForm}
														selectedEvent={selectedEvent}
														eventdocumentTypes={eventdocumentTypes}
														uploaded={uploaded}
														setUploaded={setUploaded}
													/>
												</Dialog>
											</div>
										</div>
									}
								/>
								{/* Table to show event documents */}
								<DataTable
									className="remove-border"
									size="small"
									scrollable={true}
									value={delimitationdocuments}
									dataKey="id"
									style={{ width: "100%" }}
								>
									<Column
										style={{ width: "100px", margin: "5px" }}
										align="left"
										className="my-2"
										header="#"
										body={(rowData, options) => options.rowIndex + 1}
									/>
									<Column
										style={{ width: "250px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Document Name"
										field="title"
										sortable
									></Column>
									<Column
										style={{ width: "250px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Document Type"
										field="documentType"
										sortable
									></Column>
									<Column
										style={{ width: "250px" }}
										header="Date Created"
										field="createdDate"
										body={(e) => formatDate(e.createdDate)}
										sortable
									></Column>
									<Column
										style={{ width: "250px", margin: "5px" }}
										align="left"
										className="my-2"
										header="Created By Internal"
										field="createdByInternal"
										sortable
									></Column>
									<Column
										style={{ width: "250px", margin: "5px" }}
										header="Actions"
										align="left"
										body={(rowData) => (
											<div className="flex gap-1 py-1 my-2">
												<div className="">
													<Button
														disabled={rowData.leaf}
														type="button"
														icon="pi pi-times"
														severity="danger"
														tooltip="Click to remove"
														rounded
														onClick={() => handleRemoveDocuments(rowData)}
													/>
												</div>
												<div className=" -1">
													<Button
														disabled={rowData.leaf}
														type="button"
														icon="pi pi-download"
														severity="success"
														tooltip="Click to download"
														rounded
														onClick={() => handleShowDocuments(rowData)}
													/>
												</div>
											</div>
										)}
									/>
									{/* <Column style={{ width: "250px" }} header ="Demarcation" field="dateAppointed" body={(e) => formatDate(e.dateAppointed)}  sortable></Column> */}
								</DataTable>
							</TabPanel>
						</TabView>
					</div>
				</div>
			</Dialog>
			<Dialog
				visible={ShowStaffDetails}
				onHide={() => setShowStaffDetails(false)}
				header="Staff Details"
				modal
				style={{ width: "98%", height: "98%" }}
			>
				{staffInfo ? (
					<StaffDetails
						show={ShowStaffDetails}
						setShowStaffDetails={setShowStaffDetails}
						staffInfo={staffInfo} // Ensure this is valid
					/>
				) : (
					<p>Loading staff details...</p>
				)}
			</Dialog>
			<AddEventDelimitationStaff
				show={showEventDelimitationStaffForm}
				setShow={setShowEventDelimitationStaffForm}
				selectedEvent={selectedEvent}
				form={voterForm}
				setForm={setVoterForm}
				onSubmit={SubmitForm}
				formErrorMessage={formErrorMessage}
				OnInputValidation={OnInputValidation}
				setScreenLoading={setScreenLoading}
				screenLoading={screenLoading}
			/>
			{/* </Dialog> */}

			<Dialog
				visible={showSearchElector}
				onHide={() => setShowSearchElector(false)}
				header="Search Elector"
				modal
				draggable={false}
				style={{ maxWidth: "80%", width: "80%", padding:"5px" }}
				footer={
					<>
						<Button loading={loading} className="p-button-danger" label="Cancel" onClick={() => setShowSearchElector(false)} />
						<Button
							loading={loading}
							className="p-button-success py-2"
							label="Search"
							onClick={() => {
								setLoading(false);
							}}
						/>
					</>
				}
			>
				<br/>
				<MultiFilterSearch
				className="mt-2"
					label=""
					onClear={() => {}}
					onChange={(res) => {
						setVoterData(res);
						setShowSearchElector(false)
						setVoterForm((form) => ({
							...form,
							Surname: res.surname,
							Firstname: res.firstname,
							IDNumber: res.idNumber,
							RegistrationNumber: res?.registrationNumber,
							ContactNumber: "",
							GenderID: res.genderID,
							EmailAddress: res?.email,
							Address: "",
							DateAppointed: "",
							StaffTypeID: "",
							DelimitationLevelID: "",
							DelimitationID: "",
							EventDelimitationID: selectedEvent?.eventDelimitationId,
							RoleId: "",
							EventID: selectedEvent?.eventID
						}));

						setShowEventDelimitationStaffForm(true);
					}}
					
				/>
			</Dialog>
			<Dialog
				visible={showAddParameterForm}
				onHide={() => {
					setShowAddParameterForm(false);
				}}
				style={{ height: "90%", width: "90%" }}
			>
				<AddEventPareameters
					show={showAddParameterForm}
					setShow={setShowAddParameterForm}
					parametersList={parametersList}
					setParametersList={setParametersList}
					form={form}
					setForm={setForm}
					isDelimitation={selectedEvent?.eventDelimitationLevelId === 2}
					eventCategoryID={selectedEvent?.eventCategoryID}
					eventId={selectedEvent?.eventID}
					delimitationID={selectedEvent?.eventDelimitationId}
					delimitationLeveId={selectedEvent?.eventDelimitationLevelId}
					setReloadParams={setReloadParams}
					setSavedEventParameters={GetSavedSavedEventParameters}
					savedEventParameters={savedEventParameters}
				/>
			</Dialog>
			<Dialog
				visible={showDocumentDetails}
				onHide={() => setshowDocumentDetails(false)}
				header="Document Details"
				modal
				style={{ width: "98%", height: "98%" }}
				footer={
					<>
						<Button
							className="p-button-danger"
							label="Close"
							onClick={() => {
								setshowDocumentDetails(false);
							}}
						/>
					</>
				}
			>
				<ViewDetails documentDetails={documentDetails} selectedEvent={selectedEvent} />
			</Dialog>
		</>
	);
}
